const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
};
const formatters = {
    NOK: new Intl.NumberFormat('nb-NO', { ...options, currency: 'NOK' }),
    EUR: new Intl.NumberFormat('de-DE', { ...options, currency: 'EUR' }),
    USD: new Intl.NumberFormat('en-US', { ...options, currency: 'USD' }),
};
export default function formatPrice(price, currency = 'NOK') {
    var _a;
    if (price === undefined)
        return "";
    const numberFormatter = (_a = formatters[currency]) !== null && _a !== void 0 ? _a : formatters['NOK'];
    let formatterPrice = numberFormatter.format(price);
    if (currency == 'NOK') {
        formatterPrice = formatterPrice
            .replace(",00", ",-");
    }
    return formatterPrice;
}
export function formatForeignCurrency(price, currency) {
    const foreignPrice = price * currency.rate;
    return `~ ${formatPrice(foreignPrice, currency.currency)}`;
}
export function formatPriceWs(price) {
    return formatPrice(price).replace('kr', '').trim();
}
